import { Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { HrmDiskFormat } from "../../../models/base-info/hrm-disk-format.model";

@Component({
  selector: "ngx-hrm-disk-format-form",
  templateUrl: "./hrm-disk-format-form.component.html",
  styleUrls: ["./hrm-disk-format-form.component.scss"],
})
export class HrmDiskFormatFormComponent extends BaseFormComponent<HrmDiskFormat> {
  public apiName: string = "HrmLoanKind";
  public label: string = "اطلاعات ساخت دیسکت";
  async ngOnInit() {
    super.ngOnInit();
  }
  setdefault() {
    if (this.isNewRow === true && !this.model.ANSICode) this.model.ANSICode = false;
    if (this.isNewRow === true && !this.model.HasRowHeader) this.model.HasRowHeader = false;
  }
}
